/* eslint-disable consistent-return */
/* eslint-disable no-unused-vars */
import * as settingsApi from '../api/settingsApi';
import ActionTypes from './actionTypes/index';
import links from '../../config/links';
import { showErrorPopup, showSuccessPopup } from './notification-actions';
import { errorMessage } from '../utils/displayMessageConstants';
import { fetchAuthenticatedUser } from '.';

const {
    SETTINGS_FETCH_REQUEST,
    SETTINGS_FETCH_SUCCESS,
    SETTINGS_FETCH_FAILURE,
    PREFERENCES_FEED_FETCH_REQUEST,
    PREFERENCES_FEED_FETCH_SUCCESS,
    PREFERENCES_FEED_FETCH_FAILURE,
    SETTINGS_AUSTRALIA_FETCH_REQUEST,
    SETTINGS_AUSTRALIA_FETCH_SUCCESS,
    SETTINGS_AUSTRALIA_FETCH_FAILURE,
} = ActionTypes;

const TennisValidationStatusCode = 210005;
const TENNIS_VALIDATION_POPUP_DESCRIPTION = `This is an 11-digit number that starts with 66 and can be found on your profile page on MatchCentre or the Tournament site. For more information, <a target="_blank" rel="noopener noreferrer" href=${links.supportTennisID}>Click Here</a>`;

export const updateAccountSettings = (values) => async (dispatch, getState, { mainApi }) => {
    const { auth } = getState();
    let message = 'Settings Updated';
    const isPasswordUpdated = values.password && values.password.length > 0 && values.confirmPassword && values.confirmPassword.length > 0;
    if (values.email && auth.user.email !== values.email) {
        message = 'Settings updated, Your email has been successfully updated';
    } else if (isPasswordUpdated) {
        message = 'Password Updated';
    }
    try {
        const res = await settingsApi.updateAccountSettings(mainApi, values);
        dispatch(showSuccessPopup({
            message,
        }));
        return true;
    } catch (error) {
        dispatch(showErrorPopup({
            message: isPasswordUpdated ? errorMessage.passwordUpdateFailedErrorMessage : error.response.data.DisplayMessage,
        }));
        return error;
    }
};

export const CONFIRM_EMAIL_CHANGE = 'confirm_email_change';
export const updateEmailConfirmedAfterChangedEmail = () => async (dispatch, getState) => {
    const { auth } = getState();
    auth.user.emailConfirmed = false;
    if (auth) {
        dispatch({
            type: 'confirm_email_change',
            payload: auth.user,
        });
    }
};

export const resetPassword = (email) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await settingsApi.resetPassword(mainApi, email);
        return true;
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Password Reset Failed',
            error,
        }));
    }
};

export const VALIDATE_RESET_PASSWORD_SUCCESS = 'validate_reset_password_success';
export const validateResetPassword = (values) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await settingsApi.validateResetPassword(mainApi, values);
        dispatch({ type: VALIDATE_RESET_PASSWORD_SUCCESS, payload: res });
    } catch (err) {
        throw err; // <-- Placeholder for any preprocessing needed to be done later, for now, rethrow
    }
};

export const updatePassword = (values) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await settingsApi.updatePassword(mainApi, values);
        return true;
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Password Reset Failed',
            error,
        }));
    }
};

export function getAccountSettings() {
    return (dispatch, getState, { mainApi }) => {
        dispatch({ type: SETTINGS_FETCH_REQUEST });
        settingsApi.getAccountSettings(mainApi)
            .then((result) => {
                const { data } = result;
                dispatch({ type: SETTINGS_FETCH_SUCCESS, data });
            })
            .catch((error) => {
                dispatch({ type: SETTINGS_FETCH_FAILURE });
            });
    };
}

export const getFeedPreferences = () => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({ type: PREFERENCES_FEED_FETCH_REQUEST });
        const response = await settingsApi.getFeedPreferences(mainApi);

        const { data } = response;
        if (data.error) {
            dispatch({ type: PREFERENCES_FEED_FETCH_FAILURE });
        } else {
            dispatch({ type: PREFERENCES_FEED_FETCH_SUCCESS, data });
        }
    } catch (error) {
        console.log('error get feed preference', error);
        dispatch({ type: PREFERENCES_FEED_FETCH_FAILURE });
    }
};

export const updateFeedPreferences = (values) => async (dispatch, getState, { mainApi }) => {
    try {
        await settingsApi.updateFeedPreferences(mainApi, values);
        dispatch(getFeedPreferences());
        return true;
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Update preferences failed',
            error,
        }));
        return error;
    }
};

export const markSportPreferencePromptAnswered = () => async (dispatch, getState, { mainApi }) => {
    try {
        await settingsApi.markSportPreferencePromptAnswered(mainApi);
        dispatch(fetchAuthenticatedUser());
        return true;
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Update sport preference prompt failed',
            error,
        }));
        return error;
    }
};

export const getAustraliaSettings = () => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({ type: SETTINGS_AUSTRALIA_FETCH_REQUEST });
        const response = await settingsApi.getAustraliaSettings(mainApi);

        const { data } = response;
        if (data.error) {
            dispatch({ type: SETTINGS_AUSTRALIA_FETCH_FAILURE });
        } else {
            dispatch({ type: SETTINGS_AUSTRALIA_FETCH_SUCCESS, data });
        }
    } catch (error) {
        console.log('error get feed preference', error);
    }
};

export const updateAustraliaSettings = (values) => async (dispatch, getState, { mainApi }) => {
    try {
        await settingsApi.updateAustraliaSettings(mainApi, values);
        return true;
    } catch (error) {
        if (error.response.data.MessageStatusCode === TennisValidationStatusCode) {
            dispatch(showErrorPopup({
                description: TENNIS_VALIDATION_POPUP_DESCRIPTION,
                error,
            }));
        } else {
            dispatch(showErrorPopup({
                message: 'Update australia settings failed',
                error,
            }));
        }
        return false;
    }
};

export const validateTennisConnectId = (values) => async (dispatch, getState, { mainApi }) => {
    const validateTennisConnectIdRegex = /^66\d{9}$/;
    if (values && !validateTennisConnectIdRegex.test(values)) {
        dispatch(showErrorPopup({
            message: 'Please enter valid TA tennis ID',
            error: TENNIS_VALIDATION_POPUP_DESCRIPTION,
        }));
        return false;
    }
    try {
        await settingsApi.validateTennisConnectId(mainApi, values);
        return true;
    } catch (error) {
        if (error.response.data.MessageStatusCode === TennisValidationStatusCode) {
            dispatch(showErrorPopup({
                message: TENNIS_VALIDATION_POPUP_DESCRIPTION,
                error,
            }));
        } else {
            dispatch(showErrorPopup({
                message: 'Update australia settings failed',
                error,
            }));
        }
        return false;
    }
};
